<template>
  <div class="container">
    <img src="/images/web/nodata.png" alt="页面不存在" />
    <h1 class="error-msg">很抱歉，您要访问的页面不存在！</h1>
    <p class="desc">可能原因：</p>
    <div>
      <p class="desc">网址有错误 &gt; 请检查地址是否完整或存在多余字符</p>
      <p class="desc">网址已失效 &gt; 可能页面已删除，活动已下线等</p>
    </div>
  </div>
</template>

<script>
export default {
  layout: "empty"
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* background-color: #2b91d4; */
  > img {
    width: 40%;
    margin-bottom: 10vh;
  }
}
.error-msg {
  font-size: 24px;
  color: #373d41;
  letter-spacing: 0.8px;
  line-height: 36px;
  margin-bottom: 16px;
}
.desc {
  font-size: 14px;
  color: #373d41;
  letter-spacing: 0.47px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// pages/error.vue